// src/Feedback.js
import React from 'react';
import './Feedback.css';

const Feedback = () => {
  return (
    <div className="feedback-container">
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScMMhKykB2RAdQkUPP_plhx0Bsy7m-LUx4cxClmgbRCScyYqA/viewform?embedded=true"
        width="640"
        height="840"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        title="Feedback Form"
      >
        Loading…
      </iframe>
    </div>
  );
};

export default Feedback;
